import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import background from '../img/Map.png';
import profile from '../img/unnamed.webp';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
export const OtpVerification = () => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(60);
  const [isResending, setIsResending] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  const { email, userData } = location.state || {};
  
  // Handle timer countdown
  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      
      return () => clearInterval(countdown);
    }
  }, [timer]);
  
  // Send OTP when component mounts
  useEffect(() => {
    if (email && userData) {
      sendOtp(email);
    } else {
      // If no email or userData in state, redirect back to login
      toast.error('Invalid session. Please login again.');
      navigate('/');
    }
  }, [email, userData, navigate]);


const sendOtp = async (email) => {
    setIsResending(true);
    setError('');
    
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      
      const raw = JSON.stringify({ email });
      
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };
      
      const response = await fetch("https://startx-api-otp-btqa2.ondigitalocean.app/api/otp/send-otp", requestOptions);
      const data = await response.json();
      if (response.ok) {
        toast.success('OTP sent to your email!');
        setTimer(60); 
      } else {
        setError(data.message || 'Failed to send OTP');
        toast.error('Failed to send OTP');
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      setError('Failed to send OTP. Please try again.');
      toast.error('Network error. Please try again.');
    } finally {
      setIsResending(false);
    }
  };
  const handleResendOtp = () => {
    if (timer === 0 && !isResending && email) {
      sendOtp(email);
    }
  };
  
  const handleOtpChange = (index, value) => {
    if (value === '' || /^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      
      // Auto-focus next input
      if (value !== '' && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };
  
  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === 'Backspace' && index > 0 && otp[index] === '') {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };
  
  const handleVerifyOtp = async () => {
    const otpCode = otp.join('');
    if (otpCode.length !== 6) {
      setError('Please enter a valid 6-digit OTP');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      // Verify OTP
      const response = await fetch('https://startx-api-otp-btqa2.ondigitalocean.app/api/otp/verify-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          code: otpCode
        }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        // OTP verified, now check if user is admin 
        const { uid } = userData;
        
        const adminDocRef = doc(db, "adminCollection", uid);
        const adminDoc = await getDoc(adminDocRef);
        
        if (adminDoc.exists()) {
          const adminData = adminDoc.data();
          if (adminData.docID === uid) {
            toast.success('Login Successful!', { autoClose: 3000 });
            navigate('/dashboard');
          } else {
            setError('Sorry you are not an Admin....!');
          }
        } else {
          console.error("Admin document does not exist for this user.");
          setError('Sorry you are not an Admin...!');
        }
      } else {
        setError(data.message || 'Invalid OTP. Please try again.');
        toast.error('Invalid OTP');
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setError('Failed to verify OTP. Please try again.');
      toast.error('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <>
      <div className="relative h-screen">
        <div className="absolute inset-0 z-0 flex flex-wrap items-center justify-center gap-0">
          <img src={background} alt="" />
          <div className="absolute inset-0 z-10 bg-gray-800 opacity-40"></div>
          <div className="relative z-20"></div>
        </div>
        <div className="relative z-10 flex items-center justify-center py-6 md:h-full md:py-0">
          <div className="flex flex-col items-center justify-center mx-4 bg-white rounded-[20px] shadow-md md:mx-0 w-full max-w-md">
            <div className="p-10 flex flex-col justify-between w-full rounded-[17px]">
              <div className="flex flex-col items-center">
                <img src={profile} className="h-16 mb-2 w-14" alt="Profile" />
                <h1 className="text-2xl font-bold font-krona">OTP Verification</h1>
                <p className="mt-4 text-center text-gray-600 text-md">
                  We've sent a verification code to<br />
                  <span className="font-semibold">{email}</span>
                </p>
                
                <div className="flex flex-row justify-center gap-2 mt-6">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-input-${index}`}
                      type="text"
                      maxLength="1"
                      className="w-12 h-12 text-xl font-bold text-center bg-gray-100 border rounded-md focus:border-headings focus:ring-1 focus:ring-headings focus:outline-none"
                      value={digit}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      autoFocus={index === 0}
                    />
                  ))}
                </div>
                
                <div className="mt-6 text-center">
                  {timer > 0 ? (
                    <p className="text-gray-600">
                      Resend code in <span className="font-semibold text-headings">{timer}s</span>
                    </p>
                  ) : (
                    <button 
                      className="font-semibold text-headings"
                      onClick={handleResendOtp}
                      disabled={isResending}
                    >
                      {isResending ? 'Sending...' : 'Resend OTP'}
                    </button>
                  )}
                </div>
              </div>
              
              {error && (
                <div className="mt-4 text-center">
                  <p className="text-red-600">{error}</p>
                </div>
              )}
              
              <button
                className="w-full py-3 mt-8 text-white rounded-md bg-headings disabled:bg-gray-400"
                type="button"
                onClick={handleVerifyOtp}
                disabled={loading || otp.join('').length !== 6}
              >
                {loading ? 'Verifying...' : 'Verify & Continue'}
              </button>
              
              <button
                className="w-full py-2 mt-4 bg-white border rounded-md text-headings border-headings"
                type="button"
                onClick={() => navigate('/login')}
              >
                Back to Login
              </button>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};